<template>
  <base-section
    id="efterlevandeskydd-section"
    heading="Efterlevandeskydd"
    :infoStatus="efterlevandeskydd.infoStatus"
    :show-error="efterlevandeskydd.error"
  >
    <avtalat-spinner v-if="efterlevandeskydd.isLoading" />
    <HelpText :text="helpTexts.efterlevandeskydd.efterlevandeskydd" />
    <section-row
      v-if="!efterlevandeskydd.isLoading && aterbetalningsskyddRows.length > 0"
      :title="AterbetalningsskyddTitle"
    >
      <HelpText
        :text="helpTexts.efterlevandeskydd.aterbetalningsskyddRapporterad"
      />
      <section-table
        :description="AterbetalningsskyddTitle"
        :headers="[null, 'Plan', 'Rapporterad', 'Försäkring']"
        :rows="aterbetalningsskyddRows"
      />
    </section-row>
    <section-row
      v-if="showFamiljepension"
      title="Familjepension, utbetalas livet ut"
      :is-loading="efterlevandeskydd.isLoading"
    >
      <HelpText :text="helpTexts.efterlevandeskydd.familjepension" />
      <section-row
        v-if="efterlevandeskydd.data"
        title="Avstående familjepension"
        :value="
          formatAsYesOrNo(
            efterlevandeskydd.data?.familjepension?.avstaendeFamiljepension,
          )
        "
        :is-loading="efterlevandeskydd.isLoading"
      />
      <section-row
        v-for="(efterlevandeskyddItem, index) in efterlevandeskydd.data?.familjepension
          ?.familjepensionItems"
        :key="efterlevandeskyddItem.familjepensionNamn ?? index"
        :title="efterlevandeskyddItem.familjepensionNamn ?? ''"
      >
        <section-row
          title="Fribrevsvärde"
          :value="
            formattedAmountInCurrency(
              efterlevandeskyddItem.familjepensionFribrevsvarde,
            ) ?? '-'
          "
          :value-is-numeric="true"
          :is-loading="efterlevandeskydd.isLoading"
        />
        <section-row
          title="Prognos"
          :value="
            formattedAmountInCurrency(
              efterlevandeskyddItem.familjepensionPrognos,
            ) ?? '-'
          "
          :value-is-numeric="true"
          :is-loading="efterlevandeskydd.isLoading"
        />
      </section-row>
    </section-row>
    <section-row
      v-if="efterlevandeskydd.data?.familjeskydd"
      :title="efterlevandeskydd?.data?.familjeskydd?.familjeskyddTitle ?? ''"
      :is-loading="efterlevandeskydd.isLoading"
    >
      <HelpText :text="helpTexts.efterlevandeskydd.familjeskydd" />
      <section-row
        v-if="efterlevandeskydd.data?.familjeskydd"
        title="Ersättningsbelopp per månad"
        :value="efterlevandeskydd.data?.familjeskydd?.ersattningsbeloppPerManad"
        :is-loading="efterlevandeskydd.isLoading"
      />
      <section-row
        v-if="efterlevandeskydd.data?.familjeskydd"
        title="Utbetalningstid"
        :value="efterlevandeskydd.data?.familjeskydd?.utbetalningstid"
        :is-loading="efterlevandeskydd.isLoading"
      />
    </section-row>
  </base-section>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import HelpText from "@/components/ui/HelpText.vue";
import { BaseSection, SectionRow, SectionTable } from "@/components/sections";
import helpTexts from "@/config/helpTexts";
import { formatAsYesOrNo, formattedAmountInCurrency } from "@/common/formatters";

import { useAnstalldStore } from "../store";

const anstalldStore = useAnstalldStore();
const showFamiljepension = computed(
  () =>
    anstalldStore.itp2.data &&
    anstalldStore.efterlevandeskydd.data?.familjepension,
);
const efterlevandeskydd = computed(() => anstalldStore.efterlevandeskydd);
const aterbetalningsskyddRows = computed(
  () =>
    efterlevandeskydd.value.data?.aterbetalningsskyddList?.map((x) => [
      x.forsakringsbolagsnamn,
      x.produkttyp,
      formatAsYesOrNo(x.hasAterbetalningsskydd),
      x.forsakringsnummer,
    ]) ?? [],
);

const AterbetalningsskyddTitle = computed(
  () =>
    (efterlevandeskydd.value.data?.aterbetalningsskyddHalsoprovningPagar
      ? "Återbetalningsskydd (Hälsoprövning pågår)"
      : "Återbetalningsskydd") + ", utbetalas i 5 år",
);

</script>
